import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import appReducers from '../../modules';

export default combineReducers({
	routing: routerReducer,
	form: formReducer,
	...appReducers
});



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/reducer.js